import React from 'react';
import './PlayerFactionIcon.css';
import {getPlayerHexColor} from "../../utils/players/getPlayerHexColor";
import {resolveFactionSkinIconPath} from "../../utils/factions/resolveFactionSkinIconPath";
import {LoadedImage} from "../EmblaCarousel/FactionsCarousel";
import {checkIfNeutralPlayer} from "../../utils/players/checkIfNeutralPlayer";
import {NEUTRAL_PLAYER_COLOR} from "../../constants/players";
import {getFactionConfig} from "../../utils/factions/getFactionConfig";
import VisibleBotMark from "../VisibleBotMark/VisibleBotMark";
import {checkIfBotMarkShown} from "../../utils/bots/checkIfBotMarkShown";
import FactionBanMark from "../FactionBanMark/FactionBanMark";
import RankSkinFrame from "../RankSkinFrame/RankSkinFrame";

const PlayerFactionIcon = ({
  player, factionId, skinId, className, imgClassName, onClick, onDoubleClick, backgroundColor,
  hideVisibleBotMark = false, isBanned = false, banTitle, isBanFinal = false,
}) => {
  // Нейтральный игрок никогда не имеет factionId — без явной проверки он
  // попадал в ту же ветку "фракция не выбрана" (заглушка strategikon_bust),
  // что и игрок со случайным выбором фракции. Нейтралу нужна icon_neutral.
  const effectiveFactionId = checkIfNeutralPlayer(player?.id)
    ? NEUTRAL_PLAYER_COLOR
    : (factionId || player.factionId);
  const iconPath = resolveFactionSkinIconPath(effectiveFactionId, skinId);

  const factionConfig = getFactionConfig(effectiveFactionId);

  return (
    <div
      className={`player-faction-icon-container ${isBanned ? 'player-faction-icon-container_banned' : ''} ${isBanned && isBanFinal ? 'player-faction-icon-container_banned-final' : ''} ${className}`}
      style={{
        // Обычно подложка — цвет игрока; витрины вне матча (например,
        // правила) задают свой фон явно, чтобы иконка читалась в цвете самой
        // фракции, как в инвентаре
        background: backgroundColor || getPlayerHexColor(player.color)
      }}
      onClick={onClick}
      // Двойное нажатие — отдельное действие (карточка фракции в лобби), а не
      // усиленное одиночное: браузер все равно пришлет до него два click, и
      // развести их — забота вызывающего (см. LobbyPage)
      onDoubleClick={onDoubleClick}
      // Название фракции под забаненной иконкой сбивало бы с толку: важно не
      // что это за фракция, а что играть ею уже нельзя
      title={isBanned ? (banTitle || 'Фракция забанена') : (factionConfig && factionConfig.name)}
    >
      <LoadedImage
        className={`player-faction-icon ${imgClassName}`}
        src={iconPath}
      />
      {/* Рамка рейтингового образа — поверх иконки: по ней редкий образ видно
          без подписи (см. RankSkinFrame) */}
      <RankSkinFrame skinId={skinId}/>
      {/* «Явный» бот рейтингового матча и бот локальной партии — видны всем и
          во всех режимах игры. hideVisibleBotMark — там, где значок уже стоит
          рядом с никнеймом (список игроков рейтингового лобби, см.
          LobbyPlayerName) */}
      {checkIfBotMarkShown(player) && !hideVisibleBotMark && <VisibleBotMark player={player}/>}
      {/* Бан рейтингового лобби — поверх всей иконки, а не в углу */}
      {isBanned && <FactionBanMark title={banTitle} isFinal={isBanFinal}/>}
    </div>
  );
};

export default PlayerFactionIcon;